import { render } from "./QuestionsToTags.vue?vue&type=template&id=6213b0b2&scoped=true"
import script from "./QuestionsToTags.vue?vue&type=script&lang=js"
export * from "./QuestionsToTags.vue?vue&type=script&lang=js"

import "./QuestionsToTags.vue?vue&type=style&index=0&id=6213b0b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6213b0b2"]])

export default __exports__